import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess109041Status: 'idle',
    startProcess109041Error: undefined as any,
    loadUserParamsProcess109041Status: 'idle',
    loadUserParamsProcess109041Error: undefined as any,

    process109041List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess109041 = createAsyncThunk('process109041Slice/startProcess109041', async ({ process109041 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess109041/`,
        prepareData(process109041),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess109041Status } = getState().process109041Slice
        return startProcess109041Status !== 'pending'
    }
})

export const loadUserParamsProcess109041 = createAsyncThunk('process109041Slice/loadUserParamsProcess109041', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess109041/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess109041Status } = getState().process109041Slice
        return loadUserParamsProcess109041Status !== 'pending'
    }
})

const Process109041Slice = createSlice({
    name: 'process109041Slice',
    initialState,
    reducers: {
        resetstartProcess109041: (state) => {
            state.job = undefined
            state.startProcess109041Error = undefined
        },
        resetstartProcess109041Error: (state) => {
            state.startProcess109041Error = undefined
        },
        resetloadUserParamsProcess109041: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess109041Error = undefined
        },
        resetloadUserParamsProcess109041Error: (state) => {
            state.loadUserParamsProcess109041Error = undefined
        },
        removeFromProcess109041ListById: (state, action) => {
            state.process109041List = state.process109041List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess109041ListByIds: (state, action) => {
            state.process109041List = state.process109041List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process109041List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess109041Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process109041List = []
            state.startProcess109041Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess109041.pending, (state) => {
            state.startProcess109041Status = 'pending'
            state.startProcess109041Error = undefined
        })
        builder.addCase(startProcess109041.fulfilled, (state, action) => {
            state.startProcess109041Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess109041.rejected, (state, action) => {
            state.startProcess109041Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess109041Error = action.error.message
            } else {
                state.startProcess109041Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess109041.pending, (state) => {
            state.loadUserParamsProcess109041Status = 'pending'
            state.loadUserParamsProcess109041Error = undefined
        })
        builder.addCase(loadUserParamsProcess109041.fulfilled, (state, action) => {
            state.loadUserParamsProcess109041Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess109041.rejected, (state, action) => {
            state.loadUserParamsProcess109041Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess109041Error = action.error.message
            } else {
                state.loadUserParamsProcess109041Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess109041,
    resetstartProcess109041Error,
    resetloadUserParamsProcess109041,
    resetloadUserParamsProcess109041Error,
    removeFromProcess109041ListById,
    removeFromProcess109041ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process109041Slice.actions
export default Process109041Slice.reducer
